import { Helmet } from "react-helmet-async"
import { SupplierList } from "../../../Supplier"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function TransportSupplierPage() {
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
		>
			<Helmet>
				<title>Transport Supplier</title>
			</Helmet>
			<SupplierList title="Transport Suppliers" supplierType="cabs" />
		</ForbidUnlessAuthorized>
	)
}
